import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  ImageBackground,
} from 'react-native';
import ProgressCircle from 'react-native-progress-circle';
import { useSelector } from 'react-redux';
import { AnimatedCircularProgress } from 'react-native-circular-progress';
import FastImageView from '../FastImageView';
import { getMinifiedImage } from '../../utils/ImageUtility';
import { getScreenHeight, getScreenWidth } from '../../utils/LayoutUtility';
import colors from '../../theme/Colors';
import { isBlank, isDesktop, isPresent } from '../../utils/BooleanUtility';
import { useDispatch } from 'react-redux';
import { REMOTE_CONFIG_KEYS } from '../../config/Constants';
import RemoteConfig from '../../utils/RemoteConfig';
import { jsonParser } from '../../utils/JsonUtility';
import StyleSheet from 'react-native-media-query';

const CardSelfie = (props) => {
  const {
    data,
    score: overAllScore,
    imageArr,
    background_image_url,
    labelColor,
  } = props;
  const userSelfieData = useSelector(
    (state) => state.UserAccountInfo?.selfieAnalysis,
  );
  const radius = isBlank(data) ? 115 : 125;
  const centerX = isDesktop() ? 250 : getScreenWidth() / 2;
  const centerY = (isDesktop() ? 480 : getScreenWidth()) / 1.95;
  const [showProgressOfSelfie, setShowProgressOfSelfie] = useState(false);
  const [imageStyle, setImageStyle] = useState(styles.selfieImageStyle);
  const attributeColors = jsonParser(RemoteConfig.getValue(REMOTE_CONFIG_KEYS.selfie_attributes_colors)) || {}

  const requiredAttributes = [
    'Acne',
    'Smoothness',
    'Uneven Skin',
    'Texture',
    'Redness',
    'Pigmentation',
  ];

  const getScoreColor = (score) => {
    switch (true) {
      case score <= 40:
        return attributeColors.red;
      case score <= 70:
        return attributeColors.yellow;
      default:
        return attributeColors.green;
    }
  };

  const ShowProgressCircle = ({ score, borderColor }) => {
    if (isBlank(score)) {
      return null;
    }
    let color = 'red';
    if (borderColor === 0) {
      color = attributeColors.green;
    } else if (borderColor === 1) {
      color = attributeColors.yellow;
    } else {
      color = attributeColors.red;
    }
    return (
      <>
        {!showProgressOfSelfie && (
          <ProgressCircle
            percent={88}
            radius={20}
            borderWidth={3}
            color={color}
            bgColor={colors.white}
            shadowColor={colors.white}
            outerCircleStyle={styles.outerProgressCircleStyle}
          >
            <Text style={styles.scoreTextStyle}>{`${score}%`}</Text>
          </ProgressCircle>
        )}
        {showProgressOfSelfie && (
          <View style={styles.loader}>
            <AnimatedCircularProgress
              size={40}
              width={3}
              duration={5000}
              fill={userSelfieData?.analysis_progress}
              rotation={0}
              tintColor={'#FE4C83'}
              backgroundColor={'white'}
            />
          </View>
        )}
      </>
    );
  };
  const dataToMap = isBlank(data) ? requiredAttributes : data;

  useEffect(() => {
    if (
      userSelfieData?.analysis_progress === 50 ||
      userSelfieData?.analysis_progress === 75
    ) {
      setImageStyle(styles.selfieImageStyleDuringLoading);
      setShowProgressOfSelfie(true);
    } else if (
      userSelfieData?.analysis_progress === 100 ||
      userSelfieData?.analysis_progress === 0
    ) {
      setImageStyle(styles.selfieImageStyle);
      setShowProgressOfSelfie(false);
    }
  }, [userSelfieData?.analysis_progress]);

  return (
    <View style={styles.cardStyle} dataSet={{ media: ids.cardStyle }}>
      <ImageBackground
        source={{
          uri: getMinifiedImage(
            background_image_url,
            styles.imageContainer.width,
          ),
        }}
        style={styles.imageContainer}
        resizeMode='cover'
        dataSet={{ media: ids.imageContainer }}
      >
        <View style={styles.container} dataSet={{ media: ids.container }}>
          <View dataSet={{ media: ids.selfieContainer }}>
            <FastImageView
              source={{
                uri: getMinifiedImage(
                  imageArr[0],
                  styles.selfieImageStyle.width,
                  styles.selfieImageStyle.height,
                ),
              }}
              style={imageStyle}
              resizeMode='cover'
              showLoader={true}
              dataSet={{ media: ids.selfieImageStyle }}
            />
            {showProgressOfSelfie && (
              <AnimatedCircularProgress
                size={getScreenWidth() * 0.45 + 9}
                width={4.5}
                duration={5000}
                fill={userSelfieData?.analysis_progress}
                rotation={0}
                tintColor={'#FE4C83'}
                backgroundColor={colors.silverLit}
                style={styles.selfieProgressCircle}
              />
            )}
          </View>
          {dataToMap.map((label, index) => {
            const startAngle = 110;
            const endAngle = 250;
            const angle = startAngle + (index / 5) * (endAngle - startAngle);
            const angleInRadians = (angle * Math.PI) / 180;
            const x = radius * Math.cos(angleInRadians) + centerX;
            const y = radius * Math.sin(angleInRadians) + centerY;
            const labelToShow = isBlank(data) ? label : label.attribute;
            const right = isBlank(data) ? x - 120 : x - 100;
            const top = isBlank(data) ? y - 10 : y - 12;

            let labelStyle = {
              position: 'absolute',
              right,
              top,
              width: 180,
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'center',
            };

            if (index === 1 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 75,
                top: y - 25,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 0 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 65,
                top: y - 20,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 2 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 73,
                top: y - 20,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 3 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 75,
                top: y - 15,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 4 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 78,
                top: y - 12,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 5 && isPresent(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 65,
                top: y - 18,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 1 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 113,
                top: y - 23,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 4 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 115,
                top: y,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 0 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 115,
                top: y - 18,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 2 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 105,
                top: y - 15,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 3 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 105,
                top: y - 5,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            } else if (index === 5 && isBlank(data)) {
              labelStyle = {
                position: 'absolute',
                right: x - 110,
                top: y - 8,
                width: 180,
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'center',
              };
            }

            return (
              <View key={index} style={labelStyle}>
                <View style={styles.progressCircleContainer}>
                  <ShowProgressCircle
                    score={label?.score}
                    borderColor={label?.severity}
                  />
                </View>
                <View style={[styles.labelTextContainer, { backgroundColor: labelColor || '#FFFFFF99' }]}>
                  <Text style={styles.label}>{labelToShow}</Text>
                </View>
              </View>
            );
          })}
        </View>
        {isPresent(data) && (
          <View style={styles.scoreContainer} dataSet={{ media: ids.scoreContainer }}>
            {!showProgressOfSelfie && (
              <ProgressCircle
                percent={overAllScore}
                radius={24}
                borderWidth={3}
                color={getScoreColor(overAllScore)}
                bgColor={colors.darkGreyBackground}
                shadowColor={colors.white}
                outerCircleStyle={styles.outerProgressCircleStyle}
              >
                <Text style={styles.scoreTextStyle}>{overAllScore}%</Text>
              </ProgressCircle>
            )}
            {showProgressOfSelfie && (
              <View style={styles.overAllScoreLoader} dataSet={{ media: ids.overAllScoreLoader }}>
                <AnimatedCircularProgress
                  size={48}
                  width={3}
                  duration={5000}
                  fill={userSelfieData?.analysis_progress}
                  rotation={0}
                  tintColor={'#FE4C83'}
                  backgroundColor={'white'}
                />
              </View>
            )}
            <Text style={styles.skinScoreText} dataSet={{ media: ids.skinScoreText }}>Skin Score</Text>
          </View>
        )}
      </ImageBackground>
    </View>
  );
};

const { ids, styles } = StyleSheet.create({
  container: {
    top: -50,
    left: -30,
    '@media (min-width: 768px)': {
      top: -70,
      left: -190,
      width: '90%',
      alignItems: 'center',
      justifyContent: 'center',
    }
  },
  imageContainer: {
    width: getScreenWidth(),
    height: 380,
    alignSelf: 'center',
    '@media (min-width: 768px)': {
      width: 500,
      height: 500,
      marginHorizontal: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }
  },
  selfieImageStyle: {
    width: getScreenWidth() * 0.45,
    height: getScreenWidth() * 0.45,
    position: 'absolute',
    left: getScreenWidth() * 0.13,
    top: getScreenHeight() * 0.13,
    borderRadius: (getScreenWidth() * 0.45) / 2,
    borderWidth: 5,
    borderColor: 'white',
    '@media (min-width: 768px)': {
      width: 200,
      height: 200,
      left: 50,
      top: 140,
      borderRadius: 100,
    }
  },
  selfieImageStyleDuringLoading: {
    height: getScreenWidth() * 0.45,
    width: getScreenWidth() * 0.45,
    position: 'absolute',
    top: 112,
    left: 50,
    borderRadius: (getScreenWidth() * 0.45) / 2,
    '@media (min-width: 768px)': {
      width: 200,
      height: 200,
      top: 112,
      left: 50,
      borderRadius: 100,
    }
  },
  label: {
    textAlign: 'left',
    color: 'black',
    fontSize: 14,
    fontFamily: 'Roboto-Regular',
    fontWeight: '400',
    marginLeft: 24,
    width: 88,
  },
  headingContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 12,
    paddingTop: 12,
  },
  headingText: {
    fontFamily: 'Roboto',
    fontSize: 18,
    fontWeight: '700',
    color: '#000000',
  },
  subHeadingText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: '400',
    color: colors.subtitle,
    paddingBottom: 12,
  },
  buttonStyle: {
    marginTop: 12,
    width: 75,
    backgroundColor: '#262471',
    borderRadius: 60,
    height: 25,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  buttonImage: {
    width: 10,
    height: 10,
    marginRight: 2,
  },
  scoreTextStyle: {
    fontSize: 12,
    fontWeight: 'bold',
    color: colors.black,
  },
  loader: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: colors.lightGrey,
  },
  overAllScoreLoader: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: colors.lightGrey,
  },
  skinScoreText: {
    right: 24,
    textAlign: 'center',
    width: 90,
    fontSize: 14,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    color: colors.black,
    alignSelf:'center'
  },
  scoreContainer: {
    width: 48,
    height: 48,
    position: 'absolute',
    bottom: isDesktop() ? -20 : 25,
    right: isDesktop() ? 260 : 25,
  },
  labelTextContainer: {
    backgroundColor: '#FFFFFF99',
    borderRadius: 24,
    paddingHorizontal: 5,
    paddingVertical: 2,
  },
  progressCircleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    left: 24,
    zIndex: 1,
  },
  selfieProgressCircle:{
    top: 107.8,
    left: 45.7,
  },
  outerProgressCircleStyle: {
    overflow: 'hidden',
  },
  cardStyle: {
    height: 380,
    '@media (min-width: 768px)':{
      height: 500,
    }
  }
});

export default CardSelfie;
